import React from 'react'

export const SEO = ({ title, description, children }) => {
  const seo = {
    title: title || '',
    description: description || '',
  }

  return (
    <>
      <meta charSet="utf-8" />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {children}
    </>
  )
}
